<template>
    <ModalCommon
        :id="`ModalSettingDatePublish`"
        :config="configModalSettingDatePublish"
        @close="handleCloseModalSettingDatePublish"
        @save="handleSaveSettingDatePublish"
    >
        <template>
            <!-- 開始スケジュール -->
            <div class="form-group row">
                <label class="col-sm-3 text-nowrap" style="min-width: 150px"
                    >{{ $t('managerForm.settingBasic.scheduleStart') }} <span class="text-danger">*</span></label
                >
                <div class="col-sm-9">
                    <div class="d-flex flex-wrap">
                        <div v-for="item in OPTION_PUBLIC_START_FORM" :key="item.id + 'date_now'">
                            <InputRadio
                                class="mr-4 mb-3"
                                :model.sync="formSettingDate.is_publish_start_date_now"
                                :name="`is-publish-start`"
                                :id="`is-publish-start-${item.id}`"
                                :value="item.id"
                                :label="item.name"
                                @change="onHandleChangeIsPublishStartDateNow"
                            />
                        </div>
                    </div>
                    <DateTime
                        id="select-publication-starts-date-time"
                        :full_date.sync="formSettingDate.publish_start_date"
                        :full_time.sync="formSettingDate.publish_start_time"
                        :config.sync="configSettingDate.configFieldPublicationStartDateTime"
                        :disabled="formSettingDate.is_publish_start_date_now === OPTION_PUBLIC_START_FORM[0].id"
                    >
                        <span v-if="configSettingDate.configFieldPublicationStartDateTime.error" class="invalid-feedback d-block">{{
                            configSettingDate.configFieldPublicationStartDateTime.errorText
                        }}</span>
                    </DateTime>
                </div>
            </div>
            <!-- 終了スケジュール	 -->
            <div class="form-group row">
                <label class="col-sm-3 text-nowrap" style="min-width: 150px"
                    >{{ $t('managerForm.settingBasic.scheduleEnd') }} <span class="text-danger">*</span></label
                >
                <div class="col-sm-9">
                    <div class="d-flex flex-wrap">
                        <div v-for="item in OPTION_PUBLIC_END_FORM" :key="item.id + 'end_date'">
                            <InputRadio
                                class="mr-4 mb-3"
                                :model.sync="formSettingDate.publish_has_no_end_date"
                                :name="`has_no_end`"
                                :id="`has_no_end-${item.id}`"
                                :value="item.id"
                                :label="item.name"
                                @change="onHandleChangeIsPublishEndDateNow"
                            />
                        </div>
                    </div>
                    <DateTime
                        id="select-publication-end-date-time"
                        :full_date.sync="formSettingDate.publish_end_date"
                        :full_time.sync="formSettingDate.publish_end_time"
                        :config.sync="configSettingDate.configFieldPublicationEndDateTime"
                        :disabled="formSettingDate.publish_has_no_end_date === OPTION_PUBLIC_START_FORM[0].id"
                    >
                        <span v-if="configSettingDate.configFieldPublicationEndDateTime.error" class="invalid-feedback d-block">{{
                            configSettingDate.configFieldPublicationEndDateTime.errorText
                        }}</span>
                    </DateTime>
                </div>
            </div>
            <!-- 公開パス -->
        </template>
    </ModalCommon>
</template>

<script>
import { initSettingDate, configSettingDate, OPTION_PUBLIC_START_FORM, OPTION_PUBLIC_END_FORM, STATUS_FORM_LIST } from '../../constants';
import { formatMergeDateAndTime, formatDateCommon } from '@/utils/format';
import { validateAllField } from '@/utils/validate';
import { validateEndDate } from '../../handlers';
import moment from 'moment';
import { showMessage } from '@/utils/messages';
import ModalCommon from '@/components/Modal/main.vue';
import DateTime from '@/components/DateCustoms/DateTime/main.vue';
import { InputRadio } from '@/components/Input';
import { managerFormMethods } from '@/state/helpers';

export default {
    components: {
        ModalCommon,
        DateTime,
        InputRadio
    },
    data() {
        return {
            formSettingDate: initSettingDate(),
            configSettingDate: configSettingDate(),
            OPTION_PUBLIC_START_FORM,
            OPTION_PUBLIC_END_FORM
        };
    },
    props: {
        currentRowSettingDate: {
            type: Object,
            default: () => ({})
        },
        configModalSettingDatePublish: {
            type: Object,
            required: true
        },
        screen: {
            type: String,
            default: () => 'list'
        }
    },
    methods: {
        ...managerFormMethods,
        handleOpenModalSettingDate() {
            this.formSettingDate = initSettingDate();
            this.configSettingDate = configSettingDate();
            if (
                this.currentRowSettingDate.status !== STATUS_FORM_LIST.UNPUBLISHED &&
                this.currentRowSettingDate.status !== STATUS_FORM_LIST.CREATED
            ) {
                this.onHandleChangeIsPublishEndDateNow(this.currentRowSettingDate.publish_has_no_end_date);
                if (['detail', 'edit'].includes(this.screen)) {
                    this.formSettingDate.publish_end_time = this.currentRowSettingDate?.publish_end_time;
                    this.formSettingDate.publish_end_date = this.currentRowSettingDate?.publish_end_date;
                } else {
                    this.formSettingDate.publish_end_time = formatDateCommon(this.currentRowSettingDate?.publish_end_date, 'dateTime');
                    this.formSettingDate.publish_end_date = formatDateCommon(this.currentRowSettingDate?.publish_end_date, 'date');
                }

                this.formSettingDate.publish_has_no_end_date = this.currentRowSettingDate.publish_has_no_end_date;
            } else {
                this.onHandleChangeIsPublishEndDateNow(1);
            }
            this.onHandleChangeIsPublishStartDateNow(1);
            this.configModalSettingDatePublish.id_form = this.currentRowSettingDate.id;
            this.configModalSettingDatePublish.title = this.$t('managerForm.list.settingDatePublish');
            this.configModalSettingDatePublish.model = true;
        },

        handleCloseModalSettingDatePublish() {
            this.formSettingDate = initSettingDate();
            this.configSettingDate = configSettingDate();
            this.configModalSettingDatePublish.model = false;
        },

        async handleSaveSettingDatePublish() {
            let checkDatePublish = validateAllField(this.configSettingDate);
            let checkStarPublichWithEndPublic = validateEndDate(
                this.configSettingDate['configFieldPublicationStartDateTime'],
                this.configSettingDate['configFieldPublicationEndDateTime']
            );
            if (!checkDatePublish || !checkStarPublichWithEndPublic) return;
            const nowJapan = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Tokyo' }));
            let payload = {
                id: this.configModalSettingDatePublish.id_form,
                ...this.formSettingDate,
                publish_start_date:
                    this.formSettingDate.is_publish_start_date_now === 1
                        ? moment(nowJapan).format('YYYY-MM-DD HH:mm')
                        : formatMergeDateAndTime(this.formSettingDate.publish_start_date, this.formSettingDate.publish_start_time),
                publish_end_date: formatMergeDateAndTime(this.formSettingDate.publish_end_date, this.formSettingDate.publish_end_time)
            };
            delete payload.publish_start_time;
            delete payload.publish_end_time;
            try {
                const dataRes = await this.settingPublishTime(payload);
                if (dataRes?.code !== 200) {
                    showMessage(dataRes.code, this.$bvToast, this.$t('system.error'));
                    return;
                }
                this.handleCloseModalSettingDatePublish();
                this.$emit('update-get-list');
            } catch (error) {
                console.log('error', error);
            }
        },
        onHandleChangeIsPublishStartDateNow(value) {
            this.configSettingDate.configFieldPublicationStartDateTime.error = false;
            this.formSettingDate.publish_start_date = '';
            this.formSettingDate.publish_start_time = '';
            this.configSettingDate.configFieldPublicationStartDateTime.valueSync = '';
            if (value === OPTION_PUBLIC_START_FORM[0].id) {
                this.configSettingDate.configFieldPublicationStartDateTime.typesValidate =
                    this.configSettingDate.configFieldPublicationStartDateTime.typesValidate.filter((item) => item !== 'requiredDate');
            } else {
                this.configSettingDate.configFieldPublicationStartDateTime.typesValidate.push('requiredDate');
            }
        },
        onHandleChangeIsPublishEndDateNow(value) {
            this.configSettingDate.configFieldPublicationEndDateTime.error = false;
            this.formSettingDate.publish_end_date = '';
            this.formSettingDate.publish_end_time = '';
            this.configSettingDate.configFieldPublicationEndDateTime.valueSync = '';
            if (value === OPTION_PUBLIC_END_FORM[0].id) {
                this.configSettingDate.configFieldPublicationEndDateTime.typesValidate =
                    this.configSettingDate.configFieldPublicationEndDateTime.typesValidate.filter((item) => item !== 'requiredDate');
            } else {
                this.configSettingDate.configFieldPublicationEndDateTime.typesValidate.push('requiredDate');
            }
        }
    },
    mounted() {
        this.handleOpenModalSettingDate();
    }
};
</script>
